import { handleActions } from 'redux-actions';
import { add, remove } from '../actions/loader';

const defaultState = { loaders: [] };

export const selector = ({ loader }) => (loader);

const loaderReducer = handleActions(
  {
    [add]: (state, { payload }) => {
      const existingIndex = state.loaders.findIndex((item) => item.key === payload.processId);
      const index = existingIndex !== -1 ? existingIndex : state.loaders.length;
      return {
        ...state,
        loaders: [
          ...state.loaders.slice(0, index),
          payload,
          ...state.loaders.slice(index + 1),
        ],
      };
    },
    [remove]: (state, { payload }) => ({
      ...state,
      loaders: state.loaders.filter(
        ({ processId }) => processId !== payload.processId,
      ),
    }),
  },
  defaultState,
);

export default loaderReducer;
